import Component from "../qlib/Component";
import SimpleComponentRegistery from "../qlib/SimpleComponentRegistery";
import "jquery-form";

function select_set_active(element, attribute_name, attribute_value)
{
    $(element).val('');

    let options = element.querySelectorAll('option')
    if (options === null) options = []
    Array.from(options).forEach(option => {
        $(option).attr('hidden', true);
        $(option).removeAttr('selected');

        // Safari and IE fix :(
        if (!$(option).parent().is('span')) {
            $(option).wrap('<span class="d-none"></span>');
        }
    })

    let options_active = element.querySelectorAll(`option[${attribute_name}='${attribute_value}']`)
    Array.from(options_active).forEach(option => {
        $(option).removeAttr('hidden');

        // Safari and IE fix :(
        if ($(option).parent().is('span')) {
            $(option).unwrap();
        }
    })

    let first_option = element.querySelector('option:first-of-type');
    if (first_option.value === "" || first_option.value === "none") {
        $(first_option).removeAttr('hidden');

        // Safari and IE fix :(
        if ($(first_option).parent().is('span')) {
            $(first_option).unwrap();
        }
    }

}

export default class FilterComponent extends Component
{
    constructor(element)
    {
        super(element);

        let that = this;

        this.submitTimeout;
        this.submitDelayMiliseconds = element.dataset.delay ? element.dataset.delay : 150;

        this.instant = element.dataset.instant === 'yes'
        this.instantAjax = element.dataset.instant === 'ajax'

        this.selects = {
            country: element.querySelector('.js-country-select'),
            provinces: element.querySelector('.js-province-select'),
            places: element.querySelector('.js-place-select'),
            types: element.querySelector('.js-type-select'),
            statuses: element.querySelector('.js-status-select')
        }

        if (this.selects.provinces.value) {
            this.fillPlaces();
        }

        this.selects.country.addEventListener('change', event => {
            this.sendMessage('filter', 'select_change', {
                name: 'country_id',
                instant: this.instant,
                instantAjax: this.instantAjax,
                attribute_name: 'data-country',
                attribute_value: event.target.value,
                "element": element
            })
        })

        this.selects.provinces.addEventListener('change', event => {

            this.fillPlaces();

            this.sendMessage('filter', 'select_change', {
                name: 'province_id',
                instant: this.instant,
                instantAjax: this.instantAjax,
                attribute_name: 'data-province',
                attribute_value: event.target.value,
                "element": element
            })
        })

        this.selects.places.addEventListener('change', event => {
            this.sendMessage('filter', 'select_change', {
                name: 'plaats_id',
                instant: this.instant,
                instantAjax: this.instantAjax,
                attribute_value: event.target.value,
                "element": element
            })
        })


        if (this.selects.types) {
            this.selects.types.addEventListener('change', event => {
                this.sendMessage('filter', 'select_change', {
                    name: 'attributen[1]',
                    instant: this.instant,
                    instantAjax: this.instantAjax,
                    attribute_value: event.target.value,
                    "element": element
                })
            })
        }

        if (this.selects.statuses) {
            console.log(element);
            console.log(element.querySelector('.js-status-select'));
            console.log(this.selects.statuses);
            this.selects.statuses.addEventListener('change', event => {
                this.sendMessage('filter', 'select_change', {
                    name: 'status_id',
                    instant: this.instant,
                    instantAjax: this.instantAjax,
                    attribute_value: event.target.value,
                    "element": element
                })
            })
        }

        this.otherInputs = element.querySelectorAll('.js-filter-change');
        Array.from(this.otherInputs).forEach(otherInput => {
            otherInput.addEventListener('change', event => {
                this.sendMessage('filter', 'select_change', {
                    name: this.name,
                    instant: this.instant,
                    instantAjax: this.instantAjax,
                    "element": element
                })
            })
        })

        this.geoRequest =  element.querySelectorAll('.js-filter-geo-request');
        this.geoRequestInput =  element.querySelector('.js-filter-geo-input');
        if (this.geoRequest && this.geoRequestInput) {

            if (window.location.href.match(/huidigelocatie=1/i)) {
                this.doGeoRequest();
            }

            Array.from(this.geoRequest).forEach(otherInput => {
                otherInput.addEventListener('click', event => {
                    if (event.target.nodeName !== 'INPUT') {
                        event.preventDefault();
                    }

                    this.doGeoRequest();
                })
            });
        }

        // Do first run to fix display issues on old webkit engines (span wrapper)
        // No city selected
        if (!this.selects.places.value || this.selects.places.value === "" || this.selects.places.value === "none") {
            select_set_active(this.selects.places, 'data-province', this.selects.provinces.value);
        }

    }

    fillPlaces()
    {
        this.placesTemplate = $(this.selects.places).parent().find('script.js-place-select-template');
        if (this.placesTemplate) {
            $(this.selects.places).html(this.placesTemplate.html());
            $(this.placesTemplate).remove();
        }
    }

    doGeoRequest()
    {
        let that = this;

        // Already have coords. So we are deselecting
        if (this.geoRequestInput.value) {
            this.geoRequestInput.value = '';
            that.geoRequestInput.dispatchEvent(new Event('change'));
            return;
        }

        if(!navigator.geolocation) {
            alert("Sorry uw apparaat ondersteund deze optie niet.");
        }

       navigator.geolocation.getCurrentPosition(function(pos){
            let coords = pos.coords.latitude+','+pos.coords.longitude;
            that.geoRequestInput.value = coords;
            that.geoRequestInput.dispatchEvent(new Event('change'));
       }, function(error) {
            alert("Sorry u heeft geen permissie gegeven voor het uitlezen van uw positie of uw apparaat ondersteund deze optie niet.");
       });
    }

    onMessage(type, data)
    {
        // console.log('change', data);

        switch (type)
        {
            case 'select_change':
                const name = data.name;
                switch (name) {
                    case 'country_id':
                        select_set_active(this.selects.provinces, data.attribute_name, data.attribute_value)
                    case 'province_id':
                        select_set_active(this.selects.places, data.attribute_name, data.attribute_value)
                }
                // this.selects[name + 's'].value = data.attribute_value

                // console.log(data);

                // Data element is not same as this component element.
                // Ignore further code. We only auto submit forms etc when data
                // changes on the current component form and not when we run this
                // code due a message from other instances
                if (data.element != this.element) {
                    return;
                }


                let mainForm;
                if ($(data.element).is('form')) {
                    mainForm = data.element;
                }
                if (!mainForm) {
                    mainForm = data.element.querySelector('.js-filter-form');
                }
                if (!mainForm) {
                    mainForm = data.element.closest('.js-filter-form');
                }


                if (mainForm && data.instant && this.instant)
                {
                    setTimeout(function(){
                        mainForm.submit();
                    }, this.submitDelayMiliseconds);
                    // location.href = `/aanbod?${name}=${data.attribute_value}`
                }
                else if (mainForm && data.instantAjax && this.instantAjax)
                {
                    // Clear any previous timeouts during submit delay
                    clearTimeout(this.submitTimeout);
                    this.submitTimeout = setTimeout(function(){
                        $(mainForm).ajaxSubmit({
                            dataType:  'json',
                            success: function(response){
                                let text = 'Toon <b>'+response.total+'</b>';
                                if (response.total == 1) {
                                    text += ' resultaat';
                                } else if (response.total >= 1) {
                                    text += ' resultaten';
                                } else {
                                    text = 'Geen resultaten gevonden';
                                }

                                $(data.element.querySelector('.js-button-with-total')).html(text);

                                if (response.total >= 1) {
                                    $(data.element.querySelector('.js-button-with-total')).addClass('btn-pimrary');
                                    $(data.element.querySelector('.js-button-with-total')).addClass('btn-info');
                                    $(data.element.querySelector('.js-button-with-total')).prop('disabled', false);
                                    $(data.element.querySelector('.js-button-create-zoekprofiel')).removeClass('btn-info');
                                }
                                else {
                                    $(data.element.querySelector('.js-button-with-total')).removeClass('btn-info');
                                    $(data.element.querySelector('.js-button-with-total')).removeClass('btn-primary');
                                    $(data.element.querySelector('.js-button-with-total')).prop('disabled', true);
                                    $(data.element.querySelector('.js-button-create-zoekprofiel')).addClass('btn-info');
                                }
                            }
                        });
                    }, this.submitDelayMiliseconds);
                    // location.href = `/aanbod?${name}=${data.attribute_value}`
                }
                break
        }
    }
}

SimpleComponentRegistery.register("filter", FilterComponent);
